import { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import { NavLink, useParams, Link } from "react-router-dom"

import "react-datepicker/dist/react-datepicker.css";

import { TableComponent } from "../../../shared/components/table"
import { InAppTemplate } from "../../../shared/templates/inapp";
import { storeActions } from "../../../redux/actions/in-app"
import { AlertMsg } from "../../../shared/components/alert-msg"

import { useWindowSize } from "../../../hooks/useWindowSize";

import InvoiceIco from "../../../assets/invoice.png"

import { LoadingItem } from "../../../shared/components/loading"
import "../index.scss"
import '../../../scss/ActionSlider.scss';
import NotificationPopup from '../../../views/Inapp/products/NotificationPopup';
import { ParsedVendorProduct, VendorOrder } from '../../../types/OrderTypes';
import { appConstants } from '../../../redux/action-constants/inapp.constants';
import { LoadOrderInfo } from '../../../views/Inapp/orders/LoadOrderInfo';

const getStoreOrderDetails = async ({ pageProps, payload }: any) => {

    await pageProps.getStoreOrderDetails(payload);
}

const changeOrderStatusAction = async ({ pageProps, payload, type, callback }: any) => {

    await pageProps.changeOrderStatus(payload, type, callback);
}

const getOrderShipmentLabelAction = async ({ pageProps, payload }: any) => {

    await pageProps.getOrderShipmentLabel(payload);
}

const storeSelectedStoreUrl = (urlParam: any) => {
    const index = urlParam.lastIndexOf('/');

    const slicedUrl = urlParam.slice(index + 1);

    return slicedUrl;
}



const OrderStatusCta = ({ orderId, reportData, pageProps, ctaTxt, actionFlag, isToggled, setIsToggled, setOrderStatus, setShowNotificationPopup, setShowOrderInfo, setChosenOrder, setChosenOrderInfo }: any,) => {
    const Order = reportData as VendorOrder;
    const handleToggle = () => {
        if (pageProps.getOrderShipmentLabelRequest.request_status !== "GET_SHIPMENT_LABEL_PENDING") {
            // setOrderStatus(actionFlag);
            setIsToggled(true)
        }
    };

    const handlePrintLabel = () => {
        if (Order?.orderNumber === Order?.shipmentId || !Order?.shipmentId) {
            setShowNotificationPopup(true);
        } else {
            setShowNotificationPopup(false);
            getOrderShipmentLabelAction({ pageProps, payload: Order?.shipmentId });
        }
    }

    return (
        <>
            {actionFlag === "done" && (
                <div className={`action-container ${isToggled ? "active" : "inactive"}`}>
                    <button className="btn order-no-action">
                        Order is now picked up
                    </button>
                    <button
                        className="print-btn"
                        disabled={
                            !isToggled ||
                            pageProps.getOrderShipmentLabelRequest.request_status === "GET_SHIPMENT_LABEL_PENDING"
                        }
                        onClick={handlePrintLabel}
                    >
                        Print label
                    </button>
                </div>
            )}

            {actionFlag === "is_ready" && (
                <div className={`action-container ${isToggled ? "active" : "inactive"}`}>
                    <div
                        className={`change-status-cta ${pageProps.getOrderShipmentLabelRequest.request_status === "GET_SHIPMENT_LABEL_PENDING"
                            ? "faded"
                            : ""
                            }`}
                    >
                        <span className="label-text">
                            {pageProps.getOrderShipmentLabelRequest.request_status === "GET_SHIPMENT_LABEL_PENDING"
                                ? "Please wait..."
                                : ctaTxt}
                        </span>
                        <div className={`toggle-switch ${isToggled ? "on" : "off"}`}>
                            <div className="circle">{isToggled ? "✔" : "✕"}</div>
                        </div>
                    </div>
                    <button
                        className="print-btn"
                        disabled={
                            !isToggled ||
                            pageProps.getOrderShipmentLabelRequest.request_status === "GET_SHIPMENT_LABEL_PENDING"
                        }
                        onClick={handlePrintLabel}
                    >
                        Print label
                    </button>
                </div>
            )}

            {actionFlag === "confirm_order" && (
                <div className={`action-container ${isToggled ? "active" : "inactive"}`}>
                    <div
                        className={
                            pageProps.getOrderShipmentLabelRequest.request_status === "GET_SHIPMENT_LABEL_PENDING" ||
                                pageProps.changeOrderStatusRequest.request_status === "CHANGE_ORDER_STATUS_PENDING"
                                ? "btn change-status-cta faded"
                                : "btn change-status-cta"
                        }
                        onClick={() => {
                            if (Order.orderStatus === "UnProcessed") {
                                changeOrderStatusAction({
                                    pageProps,
                                    payload: "CLEAR",
                                });
                                setChosenOrder({ id: orderId });
                                setChosenOrderInfo(Order);
                                setShowOrderInfo(true);
                            }
                        }}
                    >
                        {pageProps.getOrderShipmentLabelRequest.request_status === "GET_SHIPMENT_LABEL_PENDING"
                            ? "Please wait..."
                            : ctaTxt}
                    </div>
                    <button
                        className="print-btn"
                        disabled={
                            !isToggled ||
                            pageProps.getOrderShipmentLabelRequest.request_status === "GET_SHIPMENT_LABEL_PENDING"
                        }
                        onClick={() => {
                            setChosenOrderInfo(Order)
                            setOrderStatus("cancelled")
                        }
                        }
                    >
                        Cancel Order
                    </button>
                </div>
            )}

            {actionFlag === "cancelled" && (
                <div className={`action-container cancelled-style ${isToggled ? "active" : "inactive"}`}>
                    <div
                        className="btn change-status-cta cancelled"
                    >
                        {pageProps.getOrderShipmentLabelRequest.request_status === "GET_SHIPMENT_LABEL_PENDING"
                            ? "Please wait..."
                            : ctaTxt}
                    </div>
                </div>
            )}

        </>
    )
}

const InAppContent = ({ pageProps }: any) => {

    const hasRunRef = useRef(false);

    const [startDate, onStartChange] = useState<any>();
    const [endDate, onEndChange] = useState<any>();
    const [showDeliveryModal, setShowDeliveryModal] = useState(false);
    const [isToggled, setIsToggled] = useState<boolean>(true)
    const [orderStatusData, setOrderStatus] = useState<any>();
    const [showNotificationPopup, setShowNotificationPopup] = useState(false);
    const [showOrderInfo, setShowOrderInfo] = useState(false);
    const [chosenOrder, setChosenOrder] = useState<VendorOrder | null>(null);
    const [chosenOrderInfo, setChosenOrderInfo] = useState<VendorOrder | null>(null);
    const [fetchPayload, setFetchPayload] = useState<any>();

    useEffect(() => {
        if (!orderStatusData || hasRunRef.current) return;

        hasRunRef.current = true;

        const payload = `OrderId=${orderId}`;

        let loggedAccountInfo: any = localStorage.getItem("mamiVendorXAuth") || "{}";
        loggedAccountInfo = JSON.parse(loggedAccountInfo);

        const Orderpayload = {
            orderNumber: chosenOrderInfo?.orderNumber,
            vendorUserId: loggedAccountInfo?.userProfile?.id,
            vendorOrderProducts: chosenOrderInfo?.vendorProducts,
        };

        const callback = () => getStoreOrderDetails({ pageProps, payload });


        if (orderStatusData === "is_confirmed") {
            changeOrderStatusAction({
                pageProps,
                payload: Orderpayload,
                type: orderStatusData,
                callback,
            });
        } else if (orderStatusData === "cancelled") {
            changeOrderStatusAction({
                pageProps,
                payload: {
                    orderNumber: chosenOrderInfo?.orderNumber,
                    storeId: loggedAccountInfo?.selectedStore?.id,
                },
                type: orderStatusData,
                callback,
            });
        } else {
            changeOrderStatusAction({
                pageProps,
                payload: { orderId },
                type: orderStatusData,
                callback,
            });
        }
    }, [orderStatusData]);

    const { orderId } = useParams();
    const screenResolution: any = useWindowSize();
    let page = 1,
        size = 200;

    useEffect(() => {
        let payload = `OrderId=${orderId}`;

        // changeOrderStatusRequest({
        //     pageProps,
        //     payload: "CLEAR"
        // })


        getStoreOrderDetails({
            pageProps,
            payload
        })



    }, [])



    const ReportTable = ({ reportData }: any) => {
        // let orderList: any[] = reportData?.results;
        let loggedAccountInfo: any = localStorage.getItem("mamiVendorXAuth") || "{}";
        loggedAccountInfo = JSON.parse(loggedAccountInfo);
        let originBase = window.location.origin !== "https://vendor.mamimarkets.com" ? "https://staging.mamimarkets.com" : "https://mamimarkets.com";
        return (
            <>
                <thead>
                    <tr>
                        {/* <th>
                                <span>S/N</span>
                            </th> */}
                        <th>
                            <span>Product</span>
                        </th>
                        <th><span>Quantity Ordered</span></th>
                        <th><span>Quantity Sold</span></th>
                        <th>Category</th>
                        <th>Order Price</th>
                        <th>Final Price</th>

                        <th> <span>View </span></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        reportData.map((eachItem: any, index: any) => {
                            return (
                                <tr key={index} className={`${eachItem?.actualQuantity === 0 ? "order-product-grayed":""}`}>
                                    {/* <td>
                                            {index + 1}
                                        </td> */}
                                    <td>
                                        <div className="product-info-items">
                                            <span className="product-img"><img src={eachItem?.productUrl[0]} alt="" /></span>
                                            <span className="name-ofprod">{eachItem.name}</span>
                                        </div>

                                    </td>

                                    <td>
                                        {eachItem.quantity}
                                    </td>
                                    <td>
                                        {eachItem.actualQuantity}
                                    </td>
                                    <td>
                                        {(eachItem.categories && eachItem.categories.length >= 1) &&
                                            eachItem.categories.map((eachCar: any, catIdx: any) => {
                                                return (
                                                    <span key={catIdx} className="each-cat-txt">{eachCar}</span>
                                                )
                                            })
                                        }
                                        {!eachItem.categories && "N/A"}
                                    </td>
                                    <td>
                                        ${eachItem.subTotal}
                                    </td>
                                    <td>
                                        ${eachItem.actualSubTotal}
                                    </td>
                                    <td>
                                        <div className="view-order">
                                            <a target="_blank" href={`${originBase}/stores/${storeSelectedStoreUrl(loggedAccountInfo?.selectedStore?.url)}/products/${eachItem?.productId}`}>View product</a>
                                        </div>
                                    </td>
                                </tr>
                            )
                        })
                    }


                </tbody>
            </>
        )




    }

    const MobileDataGrid = ({ reportData }: any) => {
        let loggedAccountInfo: any = localStorage.getItem("mamiVendorXAuth") || "{}";
        loggedAccountInfo = JSON.parse(loggedAccountInfo);
        let originBase = window.location.origin !== "https://vendor.mamimarkets.com" ? "https://staging.mamimarkets.com" : "https://mamimarkets.com";
        return (
            <div className="mobile-data-grid for_details">
                {(reportData?.length >= 1) &&
                    <>
                        {reportData.map((eachItem: any, index: any) => {
                            return (
                                <div className={`"each_data_item" ${eachItem?.actualQuantity === 0 ? "order-product-grayed" : ""}`} key={index}>

                                    <div className="main-txt-head for_orders">
                                        <div className="prod_def">
                                            <div className="prod_img">
                                                <img src={eachItem?.productUrl[0]} alt="" />
                                            </div>
                                            <div className="prod_name_cat">
                                                <div className="name_only">{eachItem?.name}</div>
                                                <div className="all_cat_list">
                                                    {eachItem.categories.map((eachCat: any, idx: any) => {
                                                        return (
                                                            <span className="cate" key={idx}>
                                                                {eachCat}{idx + 1 < eachItem.categories.length ? "," : ""}
                                                            </span>
                                                        )
                                                    })}
                                                    {eachItem.categories.length === 0 ? "N/A" : ""}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="other_action">
                                            <a target="_blank" className="order_action got_to" href={`${originBase}/stores/${storeSelectedStoreUrl(loggedAccountInfo?.selectedStore?.url)}/products/${eachItem?.productId}`}>View product</a>
                                        </div>

                                    </div>
                                    <div className="each_mobile_prod_info">
                                        <div className="title-txt">Order Price </div>
                                        <div className="availables price_txt">${eachItem.subTotal} </div>
                                    </div>
                                    <div className="each_mobile_prod_info">
                                        <div className="title-txt">Final Price </div>
                                        <div className="availables price_txt">${eachItem.actualSubTotal} </div>
                                    </div>
                                    <div className="each_mobile_prod_info">
                                        <div className="title-txt">Quantity Ordered </div>
                                        <div className="availables"><span className="main_item">{eachItem?.quantity}</span><span className="measure">{eachItem?.unitOfMeasurement}(s)</span>  </div>
                                    </div>
                                    <div className="each_mobile_prod_info">
                                        <div className="title-txt">Quantity Sold </div>
                                        <div className="availables">{eachItem?.actualQuantity}{eachItem?.unitOfMeasurement}(s) </div>
                                    </div>







                                </div>
                            )
                        })}

                    </>

                }

            </div >
        )
    }

    const OrderDetails = ({ reportData }: any) => {
        let ctaTxt: any = "",
            actionFlag: any = "";

        if (reportData?.orderStatus === "PickedUp") {
            ctaTxt = "Order is now picked up"
            actionFlag = "done"
        }

        if (reportData?.orderStatus === "ReadyForPickUp") {
            ctaTxt = "Ready for Pickup"
            actionFlag = "is_ready"
        }

        if (reportData?.orderStatus === "UnProcessed") {
            ctaTxt = "Confirm Order"
            actionFlag = "confirm_order"
        }
        if (reportData?.orderStatus == "Cancelled") {
            ctaTxt = "Order Cancelled"
            actionFlag = "cancelled"
        }


        return (
            <div className="page-content lists-wrap cards with-heading order-wrap">
                <div className="orders-header">

                    <div className="order-info-head">
                        <h3>Order #{reportData?.orderNumber}</h3>
                        {screenResolution?.width >= 768 &&
                            <div className="order-ctas">

                                <OrderStatusCta orderId={orderId} reportData={reportData} pageProps={pageProps} ctaTxt={ctaTxt} actionFlag={actionFlag} isToggled={isToggled} setIsToggled={setIsToggled} setOrderStatus={setOrderStatus} setShowNotificationPopup={setShowNotificationPopup} setShowOrderInfo={setShowOrderInfo} setChosenOrder={setChosenOrder} setChosenOrderInfo={setChosenOrderInfo} />
                            </div>
                        }
                    </div>
                    <div className="orders-txt for-cart">Here, you can see the content of the cart pertinent to your store so you can properly arrange for the items to be delivered to the customer.</div>
                </div>
                <div className="order-info-head">

                    {screenResolution?.width <= 767 &&
                        <div className="order-ctas">

                            <OrderStatusCta orderId={orderId} reportData={reportData} pageProps={pageProps} ctaTxt={ctaTxt} actionFlag={actionFlag} isToggled={isToggled} setIsToggled={setIsToggled} setOrderStatus={setOrderStatus} setShowNotificationPopup={setShowNotificationPopup} setShowOrderInfo={setShowOrderInfo} setChosenOrder={setChosenOrder} setChosenOrderInfo={setChosenOrderInfo} />
                        </div>
                    }
                </div>
                <div className="list-contanier " id="order-details">

                    <div className="list-content-wrap  products-list incart">


                        <div>

                            <div className="all-items">


                                <div className="all-items-list">
                                    {screenResolution?.width >= 768 &&
                                        <TableComponent
                                            childComponent={<ReportTable reportData={reportData?.vendorProducts} />}
                                        />
                                    }

                                    {screenResolution?.width <= 767 &&
                                        <MobileDataGrid reportData={reportData?.vendorProducts} />
                                    }





                                </div>
                            </div>
                        </div>


                    </div>
                </div>
                {showOrderInfo && (
                    <LoadOrderInfo
                        pageProps={pageProps}
                        showOrderInfo={showOrderInfo}
                        setShowOrderInfo={setShowOrderInfo}
                        chosenOrder={chosenOrder}
                        chosenOrderInfo={chosenOrderInfo}
                        setChosenOrderInfo={setChosenOrderInfo}
                        fetchPayload={fetchPayload}
                        setOrderStatus={setOrderStatus}
                    />
                )}
            </div>
        )

    }
    return (
        <div className="inapp-content">

            <div className="page-content lists-wrap with-heading">

                <div className="list-contanier order-info">

                    <div className=" order-details">
                        {(pageProps.getStoreOrderDetailsRequest.request_status === appConstants.GET_VENDOR_ORDER_DETAILS_SUCCESS && pageProps.changeOrderStatusRequest.request_status !== appConstants.CHANGE_ORDER_STATUS_PENDING) &&

                            <OrderDetails reportData={pageProps.getStoreOrderDetailsRequest.request_data.response} />

                        }
                        {(pageProps.getStoreOrderDetailsRequest.request_status === appConstants.GET_VENDOR_ORDER_DETAILS_PENDING || pageProps.changeOrderStatusRequest.request_status ===  appConstants.CHANGE_ORDER_STATUS_PENDING) &&
                            <LoadingItem />
                        }
                        {pageProps.getStoreOrderDetailsRequest.request_status === appConstants.GET_VENDOR_ORDER_DETAILS_FAILURE &&
                            <AlertMsg type="error" message={pageProps.getStoreOrderDetailsRequest?.request_data.error} />
                        }
                    </div>
                </div>
            </div>
            <NotificationPopup
                isOpen={showNotificationPopup}
                onClose={() => setShowNotificationPopup(false)}
                message="Shipment Label Currently Unavailable. Please try again later."
            />
        </div>
    )
}
const OrderDetails = (pageProps: any) => {
    const screenResolution: any = useWindowSize();
    return (
        <InAppTemplate isWide={screenResolution?.width <= 1024 ? true : false} pageHeadingTitle="Orders Details" childComponent={<InAppContent pageProps={pageProps} />} />
    )
}

const mapDispatchToProps = {
    getStoreOrderDetails: storeActions.GetStoreOrderDetails,
    getStoreOrders: storeActions.GetStoreOrders,
    changeOrderStatus: storeActions.ChangeOrderStatus,
    getOrderShipmentLabel: storeActions.GetOrderShipmentLabel
};

const mapStateToProps = (state: any) => ({
    // return {
    getStoreOrdersRequest: state.allProductReducers.getStoreOrderReducer,
    getStoreOrderDetailsRequest: state.allProductReducers.getStoreOrderDetailsReducer,
    changeOrderStatusRequest: state.allProductReducers.changeOrderStatusReducer,
    getOrderShipmentLabelRequest: state.allProductReducers.getOrderShipmentLabelReducer,

    // };
})
export default connect(mapStateToProps, mapDispatchToProps)(OrderDetails);